import styled from 'styled-components';

export default styled.div`
  .probability-list-wrap .MuiFormControl-root {
    height: 20px;
    .MuiInput-root {
      height: 20px;
      input {
        height: 20px;
        line-height: 1;
        padding: 0;
        text-align: right;
      }
    }
  }
  .input-height-auto {
    .MuiFormControl-root {
      height: auto;
    }
  }
  .delete-wrap {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fafafa;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14);
  }
  .open-icon-tran {
    transform: rotate(180deg);
  }
  .input-error-style {
    color: #f44336;
    margin: 0;
    font-size: 0.75rem;
    margin-top: 7px;
    text-align: left;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.66;
    /* margin-left: 14px; */
    letter-spacing: 0.03333em;
  }
`;
